// The Session tab's "Log a workout you've done" row lives on one tab and the
// log dialog on another (Activity). A one-shot flag hands the request across
// the tab switch: set here, consumed once by SessionHistory when it mounts.
const KEY = "khronos_open_log_workout";

export const requestLogWorkout = () => {
  try {
    sessionStorage.setItem(KEY, "1");
  } catch {
    /* storage disabled: the user can still open it from Activity */
  }
};

export const consumeLogWorkoutRequest = () => {
  try {
    if (sessionStorage.getItem(KEY) !== "1") return false;
    sessionStorage.removeItem(KEY);
    return true;
  } catch {
    return false;
  }
};
